import { toast } from 'react-toastify';

/**
 * Toast helper for displaying API error messages
 * This helps debug iOS-specific issues by showing which API call failed
 */

// Show error toast with API endpoint info
export const showApiErrorToast = (endpoint, error, customMessage = null) => {
    const errorMessage = error?.response?.data?.message
        || error?.response?.data?.msg
        || error?.message
        || 'Unknown error occurred';

    const statusCode = error?.response?.status || 'N/A';

    const displayMessage = customMessage
        ? `${customMessage}: ${errorMessage}`
        : `API Error [${endpoint}] (${statusCode}): ${errorMessage}`;

    toast.error(displayMessage, {
        position: "top-right",
        autoClose: 8000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        style: {
            fontSize: '14px',
            maxWidth: '400px',
        }
    });

    // Also log to console for debugging
    console.error(`[API ERROR] ${endpoint}:`, {
        statusCode,
        message: errorMessage,
        fullError: error
    });
};

// Show success toast
export const showSuccessToast = (message) => {
    toast.success(message, {
        position: "top-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    });
};

// Show warning toast
export const showWarningToast = (message) => {
    toast.warning(message, {
        position: "top-right",
        autoClose: 5000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    });
};

// Show info toast
export const showInfoToast = (message) => {
    toast.info(message, {
        position: "top-right",
        autoClose: 4000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
    });
};

export default {
    showApiErrorToast,
    showSuccessToast,
    showWarningToast,
    showInfoToast
};
